var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "google-login-button mb-0 " },
    [
      _c(
        "g-signin-button",
        {
          staticClass: "btn btn-google",
          attrs: { params: _vm.googleSignInParams },
          on: { success: _vm.onSignInSuccess, error: _vm.onSignInError }
        },
        [
          _c("img", { attrs: { src: "/img/icons/google.svg", alt: "Google" } }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm._f("capitalize")(_vm.lang.labels.google)))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }